import { style } from "../style";

export enum AlertType {
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
  LOADING = "loading",
}

const bannerColors = {
  info: "#f7f6fe",
  success: "#f4f9f6",
  warning: "#fef8f4",
  error: "#fef5f5",
};

export const ALERT_TYPES = {
  [AlertType.INFO]: {
    icon: "alert-info",
    bgColor: bannerColors.info,
    fgColor: style.colors.purple.primary,
    borderColor: style.colors.purple.light,
    role: "status",
  },
  [AlertType.SUCCESS]: {
    icon: "alert-success",
    bgColor: bannerColors.success,
    fgColor: style.colors.green.dark,
    borderColor: style.colors.green.primary,
    role: "status",
  },
  [AlertType.WARNING]: {
    icon: "alert-warning",
    bgColor: bannerColors.warning,
    fgColor: style.colors.orange.primary,
    borderColor: style.colors.orange.light,
    role: "alert",
  },
  [AlertType.ERROR]: {
    icon: "alert-error",
    bgColor: bannerColors.error,
    fgColor: style.colors.red.dark,
    borderColor: style.colors.red.light,
    role: "alert",
  },
  [AlertType.LOADING]: {
    icon: "",
    bgColor: style.colors.blue.lightest,
    fgColor: style.colors.grey.darkest,
    borderColor: style.colors.blue.primary,
    role: "status",
  },
};
